// 大会の指定は ?id=（文書の ID）か、短い URL の /e/ST26・/entry/ST26（大会コード）である。コードは "code:ST26" の形で返す
export function eventKey(search: string, path: string): string {
  const id = new URLSearchParams(search).get("id");
  if (id) return id;
  const m = /^\/(?:e|entry)\/([A-Za-z0-9]{2,12})\/?$/.exec(path);
  return m ? `code:${m[1].toUpperCase()}` : "";
}
